<template>
  <div id="topList">
    <div
      v-for="(item, i) in navList"
      :key="i"
      @click="setAct(i)"
      :class="act === i ? 'act' : 'none'"
    >
      {{ item }}
    </div>
  </div>
</template>

<script>
export default {
  name: "topList",
  props: {
    navList: {
      type: Array,
    },
  },
  data() {
    return {
      act: 0,
    };
  },
  created(){
  },
  mounted(){},
  methods: {
    setAct(num) {
      this.act = num;
      this.$emit("setType", num);
    },
  },
};
</script>

<style lang="scss" scoped>
#topList {
  border-bottom: 3px solid #0b35c5;
  height: 48px;
  //width: 100%;
  //background: yellow;
  .act {
    width: 130px;
    height: 46px;
    background: #0b35c5;
    color: white;
    text-align: center;
    line-height: 46px;
    float: left;
    cursor: pointer;
  }

  .none {
    cursor: pointer;
    width: 130px;
    height: 46px;
    color: #333333;
    //background: white;
    text-align: center;
    line-height: 46px;

    float: left;
  }
}
</style>
